import data from './data'
import components from './components'
import computed from './computed'
import mounted from './mounted'

export default {
  data,
  components,
  computed,
  mounted,
  resourcePath: '/v1/dweller/commun/area'
}



// WEBPACK FOOTER //
// ./src/app/tenant/common-area/resources/index.js